function initCommunityUpgradesSwiper() {
  if (typeof Swiper !== 'undefined') {
    const isMobile = window.innerWidth < 800;
    
    const communityUpgradesSwiper = new Swiper('.community-upgrades__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: isMobile,
      loop: isMobile,
      breakpoints: {
        800: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false,
          loop: false
        },
        1120: {
          slidesPerView: 4,
          spaceBetween: 24,
          centeredSlides: false,
          loop: false
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 24,
          centeredSlides: false,
          loop: false
        }
      }
    });
  } else {
    setTimeout(initCommunityUpgradesSwiper, 100);
  }
}

function initLazyVideoLoading() {
  const videos = document.querySelectorAll('.community-upgrades__video[data-sources]');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const sourcesData = video.dataset.sources;
        
        if (sourcesData && !video.querySelector('source')) {
          try {
            const sources = JSON.parse('[' + sourcesData + ']');
            sources.forEach(source => {
              const sourceEl = document.createElement('source');
              sourceEl.src = source.url;
              sourceEl.type = source.type;
              video.appendChild(sourceEl);
            });
            video.load();
          } catch (e) {
            console.error('Error loading video sources:', e);
          }
        }
        observer.unobserve(video);
      }
    });
  }, {
    rootMargin: '200px'
  });
  
  videos.forEach(video => observer.observe(video));
}

function initCommunityUpgradesVideoControls() {
  const videoCards = document.querySelectorAll('[data-video-card]');

  videoCards.forEach(card => {
    const video = card.querySelector('[data-video]');
    const playBtn = card.querySelector('[data-play-btn]');
    const pauseBtn = card.querySelector('[data-pause-btn]');
    const soundBtn = card.querySelector('[data-sound-btn]');

    if (!video || !playBtn) return;

    playBtn.addEventListener('click', () => {
      pauseAllOtherVideos(video);
      video.play();
      card.classList.add('is-playing');
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        video.pause();
        card.classList.remove('is-playing');
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        const soundOffIcon = soundBtn.querySelector('.sound-off');
        const soundOnIcon = soundBtn.querySelector('.sound-on');
        if (soundOffIcon && soundOnIcon) {
          soundOffIcon.style.display = video.muted ? 'block' : 'none';
          soundOnIcon.style.display = video.muted ? 'none' : 'block';
        }
      });
    }

    video.addEventListener('ended', () => {
      card.classList.remove('is-playing');
    });
  });
}

function pauseAllOtherVideos(currentVideo) {
  const allVideos = document.querySelectorAll('.community-upgrades__video-card [data-video]');
  allVideos.forEach(video => {
    if (video !== currentVideo && !video.paused) {
      video.pause();
      video.closest('[data-video-card]').classList.remove('is-playing');
    }
  });
}

initCommunityUpgradesSwiper();
initLazyVideoLoading();
initCommunityUpgradesVideoControls();
